// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__2AfnW","approved":"Status_approved__6g7TD","rejected":"Status_rejected__13pz6","expired":"Status_expired__2Y48b","label":"Status_label__3rhlN"};